import { StatModule } from "@/core/modules/stat/objects/StatModule";

import CompanyStockView from "./views/CompanyStockView.vue";

export const companyStock: StatModule = new StatModule("warehouse", "CompanyStock", "warehouseStat", CompanyStockView);
